import { render, staticRenderFns } from "./Agreement.vue?vue&type=template&id=43c58ce9&"
import script from "./Agreement.vue?vue&type=script&lang=ts&"
export * from "./Agreement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports